// removed by extract-text-webpack-plugin
module.exports = {"thumbnail":"src-components-project-project-video-project-video-thumbnail----project-video-thumbnail-module---thumbnail---1LoTM","playButton":"src-components-project-project-video-project-video-thumbnail----project-video-thumbnail-module---playButton---ZPMQs","play":"src-components-project-project-video-project-video-thumbnail----project-video-thumbnail-module---play---431D5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-video/project-video-thumbnail/project-video-thumbnail.module.css
// module id = 537
// module chunks = 140935043865547